import { WebsocketEx, WebsocketEvents } from "@/websocket/websocketex";
import { CustomEventTarget } from "@/websocket/CustomEventTarget";
import * as telegram from "@/api/telegram";
import { message } from "ant-design-vue";
//const base_uri = "ws://127.0.0.1:9002/";

const base_uri = "ws://190.92.234.26:9002/";
//const base_uri = "ws://localhost:9002/";

//const base_uri = "ws://192.168.124.19:9002/";

interface LoginResponse {
  success: boolean;
  message: string;
  data?: {
    account: string;
    session: string;
    token: string;
  };
}

export class TelegramClient {
  private ws: WebsocketEx | null = null;
  private static instance: TelegramClient;
  private loginPromise?: {
    resolve: (value: LoginResponse) => void;
    reject: (reason: any) => void;
  };
  private loginTimeout?: NodeJS.Timeout;
  private isConnected = false;

  private eventEmitter = new CustomEventTarget();

  private constructor() {
    // Private constructor to enforce singleton pattern
  }

  static getInstance(): TelegramClient {
    if (!TelegramClient.instance) {
      TelegramClient.instance = new TelegramClient();
    }
    return TelegramClient.instance;
  }

  connect(url = base_uri): Promise<void> {
    return new Promise((resolve, reject) => {
      try {
        if (this.isConnected) {
          resolve();
          return;
        }
        if(this.ws)
        {
          return;
        }  
        this.ws = new WebsocketEx(url);

        // 临时处理连接成功
        const onConnected = () => {
          this.isConnected = true;
          this.ws?.removeEventListener(WebsocketEvents.open, onConnected);
          resolve();
        };

        this.ws.addEventListener(WebsocketEvents.open, onConnected);
        this.setupEventListeners();
        this.setupMessageListeners();

        // 连接超时处理
        setTimeout(() => {
          if (!this.isConnected) {
            reject(new Error("WebSocket connection timeout"));
          }
        }, 5000);
      } catch (error) {
        reject(error);
      }
    });
  }

  private setupEventListeners() {
    if (!this.ws) return;

    this.ws.addEventListener(WebsocketEvents.open, this.onOpen);
    this.ws.addEventListener(WebsocketEvents.close, this.onClose);
    this.ws.addEventListener(WebsocketEvents.error, this.onError);
    this.ws.addEventListener(WebsocketEvents.retry, this.onRetry);
  }

  private setupMessageListeners() {
    if (!this.ws) return;

    // 登录成功监听
    this.ws.addMessageListener(
      { type: "tg.enCommand", value: "MDM_GR_TOOLS_LOGIN" },
      { type: "tg.enCommand", value: "SUB_GR_GAME_TOOLS_LOGIN_SUCCESS" },
      {
        handler: this.onLoginSuccessMessage,
        protoName: "tg.CMD_SC_GAME_TOOLS_LOGIN_RESPONSE",
      }
    );
    this.ws.addMessageListener(
      { type: "tg.enCommand", value: "SUB_GR_GAME_TOOLS_LOAD_RESULT" },
      { type: "tg.enCommand", value: "SUB_GR_GAME_TOOLS_LOAD_RESULT" },
      {
        handler: this.onLoginSuccessError,
        protoName: "tg.operation_result",
      }
    );

    // 获取飞机账号列表结果
    this.ws.addMessageListener(
      { type: "tg.enCommand", value: "MDM_GR_TOOLS_ACCOUNT" },
      {
        type: "tg.enCommand",
        value: "SUB_GR_GAME_TOOLS_ACCOUNT_LIST_RESULT",
      },
      {
        handler: this.onGetAccountsList,
        protoName: "tg.CMD_CS_GAME_TOOLS_ACCOUNT_LIST",
      }
    );

    // 发送消息结果监听
    this.ws.addMessageListener(
      { type: "tg.enCommand", value: "MDM_GR_TOOLS_TELEGRAM" },
      {
        type: "tg.enCommand",
        value: "SUB_GR_GAME_TOOLS_TELEGRAM_SEND_RESULT",
      },
      {
        handler: this.onSendMessageResult,
        protoName: "tg.CMD_CS_IM_SEND_MESSAGE_RESPONSE",
      }
    );

    // 接收聊天更新监听
    this.ws.addMessageListener(
      { type: "tg.enCommand", value: "MDM_GR_TOOLS_TELEGRAM" },
      {
        type: "tg.enCommand",
        value: "SUB_GR_GAME_TOOLS_TELEGRAM_NEWMSG",
      },
      {
        handler: this.onReceiveChatUpdate,
        protoName: "tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY",
      }
    );


      // 添加消息监听器
      this.ws.addMessageListener(
        { type: "tg.enCommand", value: "SUB_GR_GAME_TOOLS_LOAD_RESULT" },
        { type: "tg.enCommand", value: "SUB_GR_GAME_TOOLS_LOAD_RESULT" },
        {
          handler: this.onReceiveOperationResult,
          protoName: "tg.operation_result",
        }
      );


    //接收task更新监听
    this.ws.addMessageListener(
      { type: "tg.enCommand", value: "MDM_GR_TASKS" },
      { type: "tg.enCommand", value: "MDM_GR_EXECUTE_TASK_RESULT" },
      {
        handler: this.onReceiveTaskUpdate,
        protoName: "tg.MDM_GR_EXECUTE_TASK_RSP",
      }
    );


        //接收taskLog更新监听
        this.ws.addMessageListener(
          { type: "tg.enCommand", value: "MDM_GR_TASKS" },
          { type: "tg.enCommand", value: "MDM_GR_SELECT_TASK_LOG_EVENT_RESULT" },
          {
            handler: this.onReceiveTaskLogUpdate,
            protoName: "tg.MDM_GR_GET_TASK_LOG_EVENT_RSP",
          }
        );

 
 
    // Telegram账户列表监听
    this.ws.addMessageListener(
      { type: "tg.enCommand", value: "MDM_GR_TOOLS_DATA_LOAD" },
      { type: "tg.enCommand", value: "SUB_GR_TELEGRAM_GET_LIST" },
      {
        handler: this.onTelegramAccountsList,
        protoName: "tg.CMD_TELEGRAM_ACCOUNTS_RSP",
      }
    );

    // 加载结果监听
    this.ws.addMessageListener(
      { type: "tg.enCommand", value: "MDM_GR_TOOLS_DATA_LOAD" },
      { type: "tg.enCommand", value: "SUB_GR_GAME_TOOLS_LOAD_RESULT" },
      {
        handler: this.onLoadResult,
        protoName: "tg.CMD_CS_GAME_TOOLS_BASE_RESULT",
      }
    );
    this.ws.addMessageListener(
      { type: "tg.enCommand", value: "MDM_GR_TOOLS_DATA_LOAD" },
      { type: "tg.enCommand", value: "SUB_GR_TELEGRAM_GET_LIST" },
      {
        handler: this.onLoadAccountsResult,
        protoName: "tg.CMD_TELEGRAM_ACCOUNTS_RSP",
      }
    );
  }

  private onOpen = () => {
    console.log("[WebSocket] 创建连接成功");
    this.isConnected = true;
  };

  private onClose = (instance: WebsocketEx, evt: CloseEvent) => {
    console.log(`[WebSocket] 断开连接: ${evt.code} ${evt.reason}`);
    this.isConnected = false;
    this.clearLoginState();
  };

  private onError = (instance: WebsocketEx, evt: Event) => {
    console.error("[WebSocket] 错误:", evt);
    this.clearLoginState();
  };

  private onRetry = () => {
    console.log("[WebSocket] 重新尝试连接...");
  };

  private clearLoginState() {
    if (this.loginTimeout) {
      clearTimeout(this.loginTimeout);
      this.loginTimeout = undefined;
    }

    if (this.loginPromise) {
      this.loginPromise.reject(new Error("Connection closed"));
      this.loginPromise = undefined;
    }
  }

  private onLoginSuccessError = (instance: WebsocketEx, data: any) => {
    console.log("[SC错误信息]:", data);
    if(data.code > 1)
     {
        message.warning(data.msg);
     } 
  };

  private onLoginSuccessMessage = (instance: WebsocketEx, message: any) => {
    if (!this.loginPromise) return;

    const response: LoginResponse = {
      success: true,
      message: "登录成功",
      data: {
        account: message.account,
        session: message.session,
        token: message.token,
      },
    };

    this.loginPromise.resolve(response);
    this.clearLoginState();
  };

  private onSendMessageResult = (instance: WebsocketEx, message: any) => {
    console.log("Message sent successfully:", message);
  };

  private onReceiveChatUpdate = (instance: WebsocketEx, message: any) => {
    //console.log("Received chat update:", message);
    this.eventEmitter.dispatchEvent(
      new CustomEvent("chatUpdate", {
        detail: {
          detail: message,
        },
      })
    );

  };


  private onReceiveOperationResult = (instance: WebsocketEx, message: any) => {
    this.eventEmitter.dispatchEvent(
      new CustomEvent("operationResult", {
        detail: message,
      })
    );

  };

 
  private onReceiveTaskUpdate = (instance: WebsocketEx, message: any) => {
    console.log("Received task update:", message);
    this.eventEmitter.dispatchEvent(
      new CustomEvent("taskUpdate", {
        detail: {
          index: message.index,
          receiver:message.receiver,
          sender:message.sender,
          total: message.total,
          count: message.count,
          code: message.code,
          reason: message.reason,
        },
      })
    );
    
  };

 

  private onReceiveTaskLogUpdate = (instance: WebsocketEx, message: any) => {
    console.log("Received task update:", message);
    this.eventEmitter.dispatchEvent(
      new CustomEvent("taskLogUpdate", {
        detail: message.data,
      })
    );
    
  };

 
  private onTelegramAccountsList = (instance: WebsocketEx, message: any) => {
    // console.log("Received Telegram Accounts List:");
    // message.list.forEach((account: any) => {
    // 	console.log(
    // 		`TelegramNo: ${account.strTelegramNo}, Account: ${account.strAccount}, NickName: ${account.strNickName}`
    // 	);
    // });
  };

  private onGetAccountsList = (instance: WebsocketEx, message: any) => {
    //console.log("Received Accounts List:", message);
    // message.list.forEach((account: any) => {
    // 	console.log(account);
    // });
  };

  private onLoadAccountsResult = (instance: WebsocketEx, message: any) => {
    //console.log("Load Accounts Result Code:", message.nCode);
    //console.log("Result Message:", message);
  };

  private onLoadResult = (instance: WebsocketEx, message: any) => {
    console.log("Load Result Code:", message.nCode);
    console.log("Result Message:", message.strResult);
  };

  async login(account: string, password: string): Promise<LoginResponse> {
    try {
      // 确保 WebSocket 已连接
      if (!this.isConnected) {
        await this.connect();
      }

      if (!this.ws) {
        throw new Error("WebSocket not initialized");
      }

      // 创建登录 Promise
      const loginPromise = new Promise<LoginResponse>((resolve, reject) => {
        this.loginPromise = { resolve, reject };

        // 设置登录超时
        this.loginTimeout = setTimeout(() => {
          this.clearLoginState();
          reject({
            success: false,
            message: "登录超时，请重试",
          });
        }, 10000);

        // 发送登录请求
        try {
          this.sendUserLogon(account, password);
        } catch (error) {
          this.clearLoginState();
          reject({
            success: false,
            message: "发送登录请求失败",
          });
        }
      });

      return await loginPromise;
    } catch (error) {
      return {
        success: false,
        message: error instanceof Error ? error.message : "登录失败",
      };
    }
  }

  private sendUserLogon(account: string, password: string) {
    if (!this.ws) throw new Error("WebSocket not initialized");

    const protobufData = telegram.tg.CMD_SC_GAME_TOOLS_LOGIN.create({
      account,
      password,
      token: "123456",
    });

    const mainId = telegram.tg.enCommand.MDM_GR_TOOLS_LOGIN;
    const subId = telegram.tg.enCommand.SUB_GR_GAME_TOOLS_LOGIN;

    this.ws.sendData(mainId, subId, {
      protoName: "tg.CMD_SC_GAME_TOOLS_LOGIN",
      data: protobufData,
    });
  }

  async getAccountList(strAccount: string): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!this.ws) throw new Error("WebSocket not initialized");

      // 添加消息监听器
      this.ws.addMessageListener(
        { type: "tg.enCommand", value: "MDM_GR_TOOLS_ACCOUNT" },
        {
          type: "tg.enCommand",
          value: "SUB_GR_GAME_TOOLS_ACCOUNT_LIST_RESULT",
        },
        {
          handler: (instance: WebsocketEx, message: any) => {
            resolve(message);
          },
          protoName: "tg.CMD_CS_GAME_TOOLS_ACCOUNT_LIST",
        }
      );
      const protobufData = telegram.tg.CMD_CS_IM_ACCOUNT_LIST_REQ.create({
        strAccount,
      });
      // 发送请求
      const mainId = telegram.tg.enCommand.MDM_GR_TOOLS_ACCOUNT;
      const subId = telegram.tg.enCommand.SUB_GR_GAME_TOOLS_ACCOUNT_LIST;
      this.ws.sendData(mainId, subId, {
        protoName: "tg.CMD_CS_IM_ACCOUNT_LIST_REQ",
        data: protobufData,
      });
    });
  }

  async sendPhoneNumber(account: string, phoneNum: string): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!this.ws) throw new Error("WebSocket not initialized");
      console.log("发送手机号请求:", account);
      // 添加消息监听器
      this.ws.addMessageListener(
        { type: "tg.enCommand", value: "MDM_GR_TOOLS_LOGIN" },
        {
          type: "tg.enCommand",
          value: "SUB_GR_GAME_TOOLS_LOGIN_REG_SUCCESS",
        },
        {
          handler: (instance: WebsocketEx, message: any) => {
            console.log("收到手机号验证响应:", message);
            resolve(message);
          },
          protoName: "tg.CMD_CS_GAME_TOOLS_LOGIN_REG_RESULT",
        }
      );

      // 发送请求
      const protobufData = telegram.tg.CMD_CS_GAME_TOOLS_LOGIN_REG.create({
        account,
        phoneNum,
      });
      const mainId = telegram.tg.enCommand.MDM_GR_TOOLS_LOGIN;
      const subId = telegram.tg.enCommand.SUB_GR_GAME_TOOLS_LOGIN_REG;
      this.ws.sendData(mainId, subId, {
        protoName: "tg.CMD_CS_GAME_TOOLS_LOGIN_REG",
        data: protobufData,
      });
    });
  }

  async confirmVerificationCode(
    account: string,
    phoneNum: string,
    password: string,
    strCheck: string
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!this.ws) throw new Error("WebSocket not initialized");

      // 添加消息监听器
      this.ws.addMessageListener(
        { type: "tg.enCommand", value: "MDM_GR_TOOLS_LOGIN" },
        {
          type: "tg.enCommand",
          value: "SUB_GR_GAME_TOOLS_LOGIN_CHECK_SUCCESS",
        },
        {
          handler: (instance: WebsocketEx, message: any) => {
            resolve(message);
          },
          protoName: "tg.CMD_CS_GAME_TOOLS_LOGIN_CHECK_RESULT",
        }
      );

      // 发送请求
      const protobufData = telegram.tg.CMD_CS_GAME_TOOLS_LOGIN_CHECK.create({
        account: account,
        phoneNum: phoneNum,
        password: password,
        strCheck: strCheck,
      });
      const mainId = telegram.tg.enCommand.MDM_GR_TOOLS_LOGIN;
      const subId = telegram.tg.enCommand.SUB_GR_GAME_TOOLS_LOGIN_CHECK;
      this.ws.sendData(mainId, subId, {
        protoName: "tg.CMD_CS_GAME_TOOLS_LOGIN_CHECK",
        data: protobufData,
      });
    });
  }

  async getPrivateChatList(
    username: string,
    session: string,
    nType: number
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!this.ws) throw new Error("WebSocket not initialized");

      // 添加消息监听器
      this.ws.addMessageListener(
        { type: "tg.enCommand", value: "MDM_GR_TOOLS_DATA_LOAD" },
        { type: "tg.enCommand", value: "SUB_GR_TELEGRAM_GET_LIST" },
        {
          handler: (instance: WebsocketEx, message: any) => {
            resolve(message?.list || []);
          },
          protoName: "tg.CMD_TELEGRAM_ACCOUNTS_RSP",
        }
      );

      // 发送请求
      const protobufData = telegram.tg.CMD_TELEGRAM_ACCOUNTS_REQ.create({
        username: username,
        session: session,
        type: nType,
      });
      const mainId = telegram.tg.enCommand.MDM_GR_TOOLS_DATA_LOAD;
      const subId = telegram.tg.enCommand.SUB_GR_TELEGRAM_GET_ACCOUNTS;
      this.ws.sendData(mainId, subId, {
        protoName: "tg.CMD_TELEGRAM_ACCOUNTS_REQ",
        data: protobufData,
      });
    });
  }
	// string admin = 1;	// 管理员账号
	// string phone = 2;   // 手机号
	// string msg 	 = 3;   // 发送信息

  async sendOpenForbid(
    admin:string,
    phone: string,
    msg: string,
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!this.ws) throw new Error("WebSocket not initialized");

      // 添加消息监听器
      this.ws.addMessageListener(
        { type: "tg.enCommand", value: "MDM_GR_TOOLS_LOGIN" },
        {
          type: "tg.enCommand",
          value: "SUB_GR_IM_SENDMESSAGE_UNLOCK_RESULT",
        },
        {
          handler: (instance: WebsocketEx, message: any) => {
            resolve({
              code: message.code,
              message: message.message,
            });
          },
          protoName: "tg.CMD_SC_IM_SENDMESSAGE_UNLOCK_RESULT",
        }
      );

 
      // 发送请求
      const protobufData = telegram.tg.CMD_CS_IM_SENDMESSAGE_UNLOCK.create({
        admin:admin,
        phone: phone,
        msg: msg,
      });

      const mainId = telegram.tg.enCommand.MDM_GR_TOOLS_LOGIN;
      const subId = telegram.tg.enCommand.SUB_GR_IM_SENDMESSAGE_UNLOCK;
      this.ws.sendData(mainId, subId, {
        protoName: "tg.CMD_CS_IM_SENDMESSAGE_UNLOCK",
        data: protobufData,
      });
    });
  }



 

  async sendTelegramEditUserName(
    account:string,
    phone: string,
    chat_id:number,
    first_name:string
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!this.ws) throw new Error("WebSocket not initialized");

       // 添加消息监听器
       this.ws.addMessageListener(
        { type: "tg.enCommand", value: "SUB_GR_GAME_TOOLS_LOAD_RESULT" },
        {
          type: "tg.enCommand",
          value: "SUB_GR_GAME_TOOLS_LOAD_RESULT",
        },
        {
          handler: (instance: WebsocketEx, message: any) => {
            resolve({
              message
            });
          },
          protoName: "tg.operation_result",
        }
      );

 
      // 发送请求
      const protobufData = telegram.tg.CMD_CS_IM_TELEGRAM_EDIT_USER_REQ.create({
        admin:account,
        phone: phone,
        chat_id:chat_id,
        first_name: first_name,
      });

      const mainId = telegram.tg.enCommand.MDM_GR_TOOLS_TELEGRAM;
      const subId = telegram.tg.enCommand.SUB_GR_GAME_TOOLS_TELEGRAM_EDIT_USER;
      this.ws.sendData(mainId, subId, {
        protoName: "tg.CMD_CS_IM_TELEGRAM_EDIT_USER_REQ",
        data: protobufData,
      });
    });
  }


  // string 		admin  		=	1;	// 登录用户
	// string		phone   	=	2;	// 手机号码
	// string		query   	=	3;	// 查询内容
 
  async sendTelegramSearch(
    account:string,
    phone: string,
    query:string
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!this.ws) throw new Error("WebSocket not initialized");

      // 添加消息监听器
      this.ws.addMessageListener(
        { type: "tg.enCommand", value: "MDM_GR_TOOLS_TELEGRAM" },
        {
          type: "tg.enCommand",
          value: "SUB_GR_GAME_TOOLS_TELEGRAM_SEARCH_RESULT",
        },
        {
          handler: (instance: WebsocketEx, message: any) => {
            resolve({
              message
            });
          },
          protoName: "tg.CMD_SC_IM_TELEGRAM_SEARCH_RES",
        }
      );

 
      // 发送请求
      const protobufData = telegram.tg.CMD_CS_IM_TELEGRAM_SEARCH_REQ.create({
        admin:account,
        phone: phone,
        query: query,
      });

      const mainId = telegram.tg.enCommand.MDM_GR_TOOLS_TELEGRAM;
      const subId = telegram.tg.enCommand.SUB_GR_GAME_TOOLS_TELEGRAM_SEARCH;
      this.ws.sendData(mainId, subId, {
        protoName: "tg.CMD_CS_IM_TELEGRAM_SEARCH_REQ",
        data: protobufData,
      });
    });
  }



  async sendTelegramAddUser(
    account:string,
    phone: string,
    usernick:string,
    chat_id:number
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!this.ws) throw new Error("WebSocket not initialized");

      // 添加消息监听器
      this.ws.addMessageListener(
        { type: "tg.enCommand", value: "SUB_GR_GAME_TOOLS_LOAD_RESULT" },
        {
          type: "tg.enCommand",
          value: "SUB_GR_GAME_TOOLS_LOAD_RESULT",
        },
        {
          handler: (instance: WebsocketEx, message: any) => {
            resolve({
              message
            });
          },
          protoName: "tg.operation_result",
        }
      );

 
      // 发送请求
      const protobufData = telegram.tg.CMD_CS_IM_TELEGRAM_ADDUSER_REQ.create({
        admin:account,
        phone: phone,
        usernick:usernick,
        chat_id:chat_id,
      });

      const mainId = telegram.tg.enCommand.MDM_GR_TOOLS_TELEGRAM;
      const subId = telegram.tg.enCommand.SUB_GR_GAME_TOOLS_TELEGRAM_ADDUSER;
      this.ws.sendData(mainId, subId, {
        protoName: "tg.CMD_CS_IM_TELEGRAM_ADDUSER_REQ",
        data: protobufData,
      });
    });
  }


 
  async sendGetTelegramContacts(
    account:string,
    phone: string
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!this.ws) throw new Error("WebSocket not initialized");

      // 添加消息监听器
      this.ws.addMessageListener(
        { type: "tg.enCommand", value: "MDM_GR_TOOLS_TELEGRAM" },
        {
          type: "tg.enCommand",
          value: "SUB_GR_GAME_TOOLS_TELEGRAM_CONTACTS_LIST",
        },
        {
          handler: (instance: WebsocketEx, message: any) => {
            resolve({
              message
            });
          },
          protoName: "tg.CMD_SC_IM_TELEGRAM_GET_CONTACTS_RESP",
        }
      );

 
      // 发送请求
      const protobufData = telegram.tg.CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ.create({
        admin:account,
        phone: phone
      });

      const mainId = telegram.tg.enCommand.MDM_GR_TOOLS_TELEGRAM;
      const subId = telegram.tg.enCommand.SUB_GR_GAME_TOOLS_TELEGRAM_GET_CONTACTS;
      this.ws.sendData(mainId, subId, {
        protoName: "tg.CMD_CS_IM_TELEGRAM_GET_CONTACTS_REQ",
        data: protobufData,
      });
    });
  }




  async sendMessage(
    account:string,
    fromAccount: string,
    targets: Array<{ Id?: number; name?: string }>,
    message: string,
    typeMsg: number
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!this.ws) throw new Error("WebSocket not initialized");

      // 添加消息监听器
      this.ws.addMessageListener(
        { type: "tg.enCommand", value: "MDM_GR_TOOLS_TELEGRAM" },
        {
          type: "tg.enCommand",
          value: "SUB_GR_GAME_TOOLS_TELEGRAM_SEND_RESULT",
        },
        {
          handler: (instance: WebsocketEx, message: any) => {
            resolve({
              code: message.code,
              message: message.message,
            });
          },
          protoName: "tg.CMD_CS_IM_SEND_MESSAGE_RESPONSE",
        }
      );

      // 构造 ChatTarget 数组
      const chatTargets = targets.map((target: telegram.tg.IChatTarget) => {
        if (target.Id) {
          return { Id: target.Id };
        }
        return { name: target.name };
      });

      // 发送请求
      const protobufData = telegram.tg.CMD_CS_IM_SEND_MESSAGE.create({
        admin:account,
        from: fromAccount,
        targets: chatTargets,
        message: message,
        type: typeMsg,
      });

      const mainId = telegram.tg.enCommand.MDM_GR_TOOLS_TELEGRAM;
      const subId = telegram.tg.enCommand.SUB_GR_GAME_TOOLS_TELEGRAM_SEND;
      this.ws.sendData(mainId, subId, {
        protoName: "tg.CMD_CS_IM_SEND_MESSAGE",
        data: protobufData,
      });
    });
  }

  // 请求客户端私聊数据
  async getPrivateChatData(username: string, token: string,limit:number): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!this.ws) throw new Error("WebSocket not initialized");
      // 添加消息监听器
      this.ws.addMessageListener(
        { type: "tg.enCommand", value: "MDM_GR_TOOLS_TELEGRAM" },
        {
          type: "tg.enCommand",
          value: "SUB_GR_GAME_TOOLS_TELEGRAM_RECV_RESULT",
        },
        {
          handler: (instance: WebsocketEx, message: any) => {
            resolve(message);
          },
          protoName: "tg.CMD_SC_IM_TELEGRAM_CHAT_HISTORY",
        }
      );
      // 发送请求
      const protobufData = telegram.tg.CMD_CS_IM_TELEGRAM_CHAT_REQ.create({
        username,
        token,
        limit,
      });

      const mainId = telegram.tg.enCommand.MDM_GR_TOOLS_TELEGRAM;
      const subId = telegram.tg.enCommand.SUB_GR_GAME_TOOLS_TELEGRAM_RECV;
      this.ws.sendData(mainId, subId, {
        protoName: "tg.CMD_CS_IM_TELEGRAM_CHAT_REQ",
        data: protobufData,
      });
    });
  }



  // 请求客户端私聊数据  HISTORY_REQ
  async getPrivateChatDataHistory(phone: string, chat_id: number,limit:number): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!this.ws) throw new Error("WebSocket not initialized");
      // 添加消息监听器
      this.ws.addMessageListener(
        { type: "tg.enCommand", value: "MDM_GR_TOOLS_TELEGRAM" },
        {
          type: "tg.enCommand",
          value: "SUB_GR_GAME_TOOLS_TELEGRAM_HISTORY_RESULT",
        },
        {
          handler: (instance: WebsocketEx, message: any) => {
            resolve(message);
          },
          protoName: "tg.CMD_SC_IM_TELEGRAM_CHAT_NOTIFY",
        }
      );
      // 发送请求
      const protobufData = telegram.tg.CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ.create({
        phone,
        chat_id,
        limit,
      });
 
      const mainId = telegram.tg.enCommand.MDM_GR_TOOLS_TELEGRAM;
      const subId = telegram.tg.enCommand.SUB_GR_GAME_TOOLS_TELEGRAM_CUR_HISTORY;
      this.ws.sendData(mainId, subId, {
        protoName: "tg.CMD_CS_IM_TELEGRAM_CUR_HISTORY_REQ",
        data: protobufData,
      });
    });
  }



  disconnect() {
    if (this.ws) {
      this.ws.close(1000);
      this.ws = null;
      this.isConnected = false;
      this.clearLoginState();
    }
  }

  // 添加监听方法
  public addChatUpdateListener(callback: (data: any) => void) {

    this.eventEmitter.addEventListener("chatUpdate",callback);

  }

  public removeChatUpdateListener(callback: (data: any) => void)
  {
     this.eventEmitter.removeEventListener("chatUpdate",callback);
  }


  public addOperationResultListener(callback: (data: any) => void) {

    this.eventEmitter.addEventListener("operationResult",callback);

  }

  public removeOperationResultListener(callback: (data: any) => void)
  {
     this.eventEmitter.removeEventListener("operationResult",callback);
  }



  public addTaskUpdateListener(callback: (data: any) => void) {
    this.eventEmitter.addEventListener("taskUpdate",callback);
  
  }

 
  public addTaskLogUpdateListener(callback: (data: any) => void) {
    this.eventEmitter.addEventListener("taskLogUpdate",callback);
  
  }


  public removeTaskUpdateListener(callback: (data: any) => void)
  {
     this.eventEmitter.removeEventListener("taskUpdate",callback);
  }

  public removeTaskLogUpdateListener(callback: (data: any) => void)
  {
     this.eventEmitter.removeEventListener("taskLogUpdate",callback);
  }

  async loadPrivateChatList(
    list: Array<{
      strAccount: string;
      strTelegramNo?: string;
      strNickName?: string;
      strPhone?: string;
      strManage?: string;
    }>
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!this.ws) throw new Error("WebSocket not initialized");

      // 添加消息监听器
      this.ws.addMessageListener(
        {
          type: "tg.enCommand",
          value: "SUB_GR_GAME_TOOLS_LOAD_RESULT",
        },
        {
          type: "tg.enCommand",
          value: "SUB_GR_GAME_TOOLS_LOAD_RESULT",
        },
        {
          handler: (instance: WebsocketEx, message: any) => {
            //console.log("批量导入结果:", message);
            resolve(message);
          },
          protoName: "tg.operation_result",
        }
      );

      // 直接使用传入的list创建protobuf数据
      const protobufData = telegram.tg.CMD_GAME_TOOLS_LOAD_TELEGRAMS.create({
        list: list,
      });

      //console.log("发送的protobuf数据:", protobufData);

      const mainId = telegram.tg.enCommand.MDM_GR_TOOLS_DATA_LOAD;
      const subId = telegram.tg.enCommand.SUB_GR_GAME_TOOLS_TELEGRAM_LOAD;

      this.ws.sendData(mainId, subId, {
        protoName: "tg.CMD_GAME_TOOLS_LOAD_TELEGRAMS",
        data: protobufData,
      });
    });
  }

  async deleteAllPrivateChat(account: string, token: string): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!this.ws) throw new Error("WebSocket not initialized");

      // 添加消息监听器
      this.ws.addMessageListener(
        { type: "tg.enCommand", value: "SUB_GR_GAME_TOOLS_LOAD_RESULT" },
        { type: "tg.enCommand", value: "SUB_GR_GAME_TOOLS_LOAD_RESULT" },
        {
          handler: (instance: WebsocketEx, message: any) => {
            resolve(message);
          },
          protoName: "tg.operation_result",
        }
      );

      // 发送请求
      const protobufData = telegram.tg.CMD_IM_PRIVATE_DELETE.create({
        account: account,
        token: token,
      });

      const mainId = telegram.tg.enCommand.MDM_GR_TOOLS_DATA_LOAD;
      const subId = telegram.tg.enCommand.SUB_GR_GAME_TOOLS_PRIVATE_DELETE;
      this.ws.sendData(mainId, subId, {
        protoName: "tg.CMD_IM_PRIVATE_DELETE",
        data: protobufData,
      });
    });
  }

  async deleteAccount(account: string, phoneNum: string): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!this.ws) throw new Error("WebSocket not initialized");

      // 添加消息监听器
      this.ws.addMessageListener(
        { type: "tg.enCommand", value: "MDM_GR_TOOLS_LOGIN" },
        {
          type: "tg.enCommand",
          value: "SUB_GR_GAME_TOOLS_LOGIN_DELETE_SUCCESS",
        },
        {
          handler: (instance: WebsocketEx, message: any) => {
            resolve(message);
          },
          protoName: "tg.CMD_SC_IM_DELETE_ACCOUNT_RESULT",
        }
      );

      // 发送请求
      const protobufData = telegram.tg.CMD_CS_IM_DELETE_ACCOUNT.create({
        account,
        phoneNum,
      });
      const mainId = telegram.tg.enCommand.MDM_GR_TOOLS_LOGIN;
      const subId = telegram.tg.enCommand.SUB_GR_GAME_TOOLS_LOGIN_DELETE;
      this.ws.sendData(mainId, subId, {
        protoName: "tg.CMD_CS_IM_DELETE_ACCOUNT",
        data: protobufData,
      });
    });
  }

  // 创建任务
  async createTask(
    account: string,
    taskData: {
      task_type: number;
      phones: string[];
      targets: Array<{ Id?: number; name?: string }>;
      msg_type: number;
      message: string;
      start_time: number;
      end_time: number;
      interval: number;
      remark?: string;
    }
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!this.ws) throw new Error("WebSocket not initialized");

      // 添加消息监听器
      this.ws.addMessageListener(
        { type: "tg.enCommand", value: "MDM_GR_TASKS" },
        { type: "tg.enCommand", value: "MDM_GR_CREATE_TASK_RESULT" },
        {
          handler: (instance: WebsocketEx, message: any) => {
            resolve(message);
          },
          protoName: "tg.MDM_GR_CREATE_TASK_RSP",
        }
      );

      // 构造完整的任务数据
      const fullTaskData: telegram.tg.ITAG_TASK_INFO = {
        index: 0,
        status: 1,
        phone: taskData.phones,
        targets: taskData.targets.map((target) => {
          if (typeof target.Id === "number") {
            return { Id: target.Id };
          }
          return { name: target.name };
        }),
        message: taskData.message,
        task_type: Number(taskData.task_type),
        msg_type: Number(taskData.msg_type),
        start_time: Number(taskData.start_time),
        end_time: Number(taskData.end_time),
        interval: Number(taskData.interval),
        account: account,
        create_time: new Date().toISOString(),
        remark: taskData.remark || "",
      };
      // 打印日志检查数据
      //console.log('发送的任务数据:', fullTaskData);

      // 发送请求
      const protobufData = telegram.tg.MDM_GR_CREATE_TASK_REQ.create({
        account: account,
        data: fullTaskData,
      });

      const mainId = telegram.tg.enCommand.MDM_GR_TASKS;
      const subId = telegram.tg.enCommand.MDM_GR_CREATE_TASK;
      this.ws.sendData(mainId, subId, {
        protoName: "tg.MDM_GR_CREATE_TASK_REQ",
        data: protobufData,
      });
    });
  }


  //查询代理
  async proxyUserCheck(
    account: string,

  ): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!this.ws) throw new Error("WebSocket not initialized");

      // 添加消息监听器
      this.ws.addMessageListener(
        { type: "tg.enCommand", value: "MDM_GR_TOOLS_LOGIN" },
        { type: "tg.enCommand", value: "SUB_GR_IM_NET_PROXY_USER_LIST" },
        {
          handler: (instance: WebsocketEx, message: any) => {
            resolve(message);
          },
          protoName: "tg.CMD_SC_IM_NET_PROXY_USER_LIST",
        }
      );

 

      const protobufData = telegram.tg.CMD_CS_IM_NET_PROXY_USER_CHECK.create({
        admin:account
      });


      const mainId = telegram.tg.enCommand.MDM_GR_TOOLS_LOGIN;
      const subId = telegram.tg.enCommand.SUB_GR_IM_NET_PROXY_USER_CHECK;
      this.ws.sendData(mainId, subId, {
        protoName: "tg.CMD_CS_IM_NET_PROXY_USER_CHECK",
        data: protobufData,
      });
    });

  }

 
 async proxyAllocate(
  account: string,
  phoneNum: string,
): Promise<any> {
  return new Promise((resolve, reject) => {
    if (!this.ws) throw new Error("WebSocket not initialized");
        this.ws.addMessageListener(
          { type: "tg.enCommand", value: "SUB_GR_GAME_TOOLS_LOAD_RESULT" },
          { type: "tg.enCommand", value: "SUB_GR_GAME_TOOLS_LOAD_RESULT" },
          {
            handler: (instance: WebsocketEx, message: any) => {
              resolve(message);
            },
            protoName: "tg.operation_result",
          }
        );

    const protobufData = telegram.tg.CMD_CS_IM_NET_PROXY_ALLOCATE.create({
      admin:account,
      phoneNum:phoneNum
    });

    const mainId = telegram.tg.enCommand.MDM_GR_TOOLS_LOGIN;
    const subId = telegram.tg.enCommand.SUB_GR_IM_NET_PROXY_ALLOCATE;
    this.ws.sendData(mainId, subId, {
      protoName: "tg.CMD_CS_IM_NET_PROXY_ALLOCATE",
      data: protobufData,
    });
  });

}



  //查询代理
  async fetchAgents(
    account: string,

  ): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!this.ws) throw new Error("WebSocket not initialized");

      // 添加消息监听器
      this.ws.addMessageListener(
        { type: "tg.enCommand", value: "MDM_GR_TOOLS_LOGIN" },
        { type: "tg.enCommand", value: "SUB_GR_IM_NET_PROXY_LIST" },
        {
          handler: (instance: WebsocketEx, message: any) => {
            resolve(message);
          },
          protoName: "tg.CMD_SC_IM_NET_PROXY_LIST",
        }
      );

      
 

      const protobufData = telegram.tg.CMD_CS_IM_NET_PROXY_QUERY.create({
        admin:account
      });


      const mainId = telegram.tg.enCommand.MDM_GR_TOOLS_LOGIN;
      const subId = telegram.tg.enCommand.SUB_GR_IM_NET_PROXY_QUERY;
      this.ws.sendData(mainId, subId, {
        protoName: "tg.CMD_CS_IM_NET_PROXY_QUERY",
        data: protobufData,
      });
    });

  }
 
  //添加网络代理命令
  async createQueryAgent(
    
    proxy_info:{
      admin:string,
      phoneNum:string,
      proxyId:number,
    }

  ): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!this.ws) throw new Error("WebSocket not initialized");

 
      const protobufData = telegram.tg.CMD_CS_IM_NET_PROXY_ALLOCATE.create({
        admin:proxy_info.admin,
        phoneNum:proxy_info.phoneNum,
        proxyId:proxy_info.proxyId,
      });


      const mainId = telegram.tg.enCommand.MDM_GR_TOOLS_LOGIN;
      const subId = telegram.tg.enCommand.SUB_GR_IM_NET_PROXY_ALLOCATE;
      this.ws.sendData(mainId, subId, {
        protoName: "tg.CMD_CS_IM_NET_PROXY_ALLOCATE",
        data: protobufData,
      });
    });
  }


  //添加网络代理命令
  async createAgent(
    
    proxy_info:{
      proxy_type:number,
      address:string,
      port:number,
      username:string,
      password:string,
      secret_key:string,
    }

  ): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!this.ws) throw new Error("WebSocket not initialized");

      // 添加消息监听器
      this.ws.addMessageListener(
        { type: "tg.enCommand", value: "MDM_GR_TOOLS_LOGIN" },
        { type: "tg.enCommand", value: "SUB_GR_IM_NET_PROXY_LIST" },
        {
          handler: (instance: WebsocketEx, message: any) => {
            resolve(message);
          },
          protoName: "tg.CMD_SC_IM_NET_PROXY_LIST",
        }
      );

     let proxyInfo = telegram.tg.proxy_info.create({
      proxy_type:proxy_info.proxy_type,
      address:proxy_info.address,
      port:proxy_info.port,
      username:proxy_info.username,
      password:proxy_info.password,
      secret_key:proxy_info.secret_key,
    });

      const protobufData = telegram.tg.CMD_CS_IM_NET_PROXY_ADD.create({
        data:proxyInfo
      });


      const mainId = telegram.tg.enCommand.MDM_GR_TOOLS_LOGIN;
      const subId = telegram.tg.enCommand.SUB_GR_IM_NET_PROXY_ADD;
      this.ws.sendData(mainId, subId, {
        protoName: "tg.CMD_CS_IM_NET_PROXY_ADD",
        data: protobufData,
      });
    });
  }



    // 删除任务
  async deleteAgent(account: string, agentId: number[]): Promise<any> {
      return new Promise((resolve, reject) => {
        if (!this.ws) throw new Error("WebSocket not initialized");
  
        // 添加消息监听器
	      this.ws.addMessageListener(
          { type: "tg.enCommand", value: "SUB_GR_GAME_TOOLS_LOAD_RESULT" },
          { type: "tg.enCommand", value: "SUB_GR_GAME_TOOLS_LOAD_RESULT" },
          {
            handler: (instance: WebsocketEx, message: any) => {
              resolve(message);
            },
            protoName: "tg.operation_result",
          }
        );
        
  
        // 发送请求
        const protobufData = telegram.tg.CMD_CS_IM_NET_PROXY_DELETE.create({
          admin: account,
          index: agentId,
        });
  
        const mainId = telegram.tg.enCommand.MDM_GR_TOOLS_LOGIN;
        const subId = telegram.tg.enCommand.SUB_GR_IM_NET_PROXY_DELETE;
        this.ws.sendData(mainId, subId, {
          protoName: "tg.CMD_CS_IM_NET_PROXY_DELETE",
          data: protobufData,
        });
      });
    }



  // 获取任务列表
  async getTaskList(account: string): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!this.ws) throw new Error("WebSocket not initialized");

      // 添加消息监听器
      this.ws.addMessageListener(
        { type: "tg.enCommand", value: "MDM_GR_TASKS" },
        { type: "tg.enCommand", value: "MDM_GR_SELECT_TASK_RESULT" },
        {
          handler: (instance: WebsocketEx, message: any) => {
            //console.log("获取任务列表结果:", message);
            resolve(message);
          },
          protoName: "tg.MDM_GR_SELECT_TASK_RSP",
        }
      );

      // 发送请求
      const protobufData = telegram.tg.MDM_GR_SELECT_TASK_REQ.create({
        account,
      });

      const mainId = telegram.tg.enCommand.MDM_GR_TASKS;
      const subId = telegram.tg.enCommand.MDM_GR_SELECT_TASK;
      this.ws.sendData(mainId, subId, {
        protoName: "tg.MDM_GR_SELECT_TASK_REQ",
        data: protobufData,
      });
    });
  }

  // 删除任务
  async deleteTask(account: string, taskId: number[]): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!this.ws) throw new Error("WebSocket not initialized");

      // 添加消息监听器
      this.ws.addMessageListener(
        { type: "tg.enCommand", value: "MDM_GR_TASKS" },
        { type: "tg.enCommand", value: "MDM_GR_DELETE_TASK_RESULT" },
        {
          handler: (instance: WebsocketEx, message: any) => {
            resolve(message);
          },
          protoName: "tg.MDM_GR_DELETE_TASK_RSP",
        }
      );

      // 发送请求
      const protobufData = telegram.tg.MDM_GR_DELETE_TASK_REQ.create({
        account: account,
        index: taskId,
      });

      const mainId = telegram.tg.enCommand.MDM_GR_TASKS;
      const subId = telegram.tg.enCommand.MDM_GR_DELETE_TASK;
      this.ws.sendData(mainId, subId, {
        protoName: "tg.MDM_GR_DELETE_TASK_REQ",
        data: protobufData,
      });
    });
  }


 
  // 执行任务
  async executeTask(account: string, taskId: number[]): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!this.ws) throw new Error("WebSocket not initialized");

      // 添加消息监听器
      this.ws.addMessageListener(
        { type: "tg.enCommand", value: "MDM_GR_TASKS" },
        { type: "tg.enCommand", value: "MDM_GR_EXECUTE_TASK_RESULT" },
        {
          handler: (instance: WebsocketEx, message: any) => {
            resolve(message);
          },
          protoName: "tg.MDM_GR_EXECUTE_TASK_RSP",
        }
      );

      // 发送请求
      const protobufData = telegram.tg.MDM_GR_EXECUTE_TASK_REQ.create({
        account: account,
        index: taskId,
      });

      const mainId = telegram.tg.enCommand.MDM_GR_TASKS;
      const subId = telegram.tg.enCommand.MDM_GR_EXECUTE_TASK;
      this.ws.sendData(mainId, subId, {
        protoName: "tg.MDM_GR_EXECUTE_TASK_REQ",
        data: protobufData,
      });
    });
  }

  // 任务日志
  async getTaskLog(account: string, taskId: number[]): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!this.ws) throw new Error("WebSocket not initialized");

      // 添加消息监听器
      this.ws.addMessageListener(
        { type: "tg.enCommand", value: "MDM_GR_TASKS" },
        { type: "tg.enCommand", value: "MDM_GR_SELECT_TASK_LOG_RESULT" },
        {
          handler: (instance: WebsocketEx, message: any) => {
            resolve(message);
          },
          protoName: "tg.MDM_GR_GET_TASK_LOG_RSP",
        }
      );

      // 发送请求
      const protobufData = telegram.tg.MDM_GR_GET_TASK_LOG_REQ.create({
        account: account,
        index: taskId,
        limit:100,
      });

      const mainId = telegram.tg.enCommand.MDM_GR_TASKS;
      const subId = telegram.tg.enCommand.MDM_GR_SELECT_TASK_LOG;
      this.ws.sendData(mainId, subId, {
        protoName: "tg.MDM_GR_GET_TASK_LOG_REQ",
        data: protobufData,
      });
    });
  }



  // 任务更新日志
  async getTaskLogEvent(account: string,session:string): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!this.ws) throw new Error("WebSocket not initialized");

      // 发送请求
      const protobufData = telegram.tg.MDM_GR_GET_TASK_LOG_EVENT.create({
        account: account,
        session:session,
      });
      const mainId = telegram.tg.enCommand.MDM_GR_TASKS;
      const subId = telegram.tg.enCommand.MDM_GR_SELECT_TASK_LOG_EVENT;//510
      this.ws.sendData(mainId, subId, {
        protoName: "tg.MDM_GR_GET_TASK_LOG_EVENT",
        data: protobufData,
      });
    });
  }



}
